import { connect } from 'react-redux';
import Lane from '../components/lane';
import { setLaneInfo } from '../../../containers/gantt-actions';

const mapStateToProps = state => ({
  ganttDimensions: state.gantt.ganttDimensions,
  viewDimensions: state.gantt.viewDimensions,
  dateReference: state.gantt.dateReference,
  view: state.gantt.view,
});

const mapDispatchToProps = {
  setLaneInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Lane);
